import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index.vue'
import About from '../components/About.vue'
// import Service from '../components/Service.vue'
import Contact from '../components/Contact.vue'
import Rent from '../views/Rent/index.vue'
import Transfer from '../views/Transfer/index.vue'
import Vich from '../views/Vich/index.vue'
import Order from '../views/Order/index.vue'
import Wantjob from '../views/Wantjob/index.vue'
import Pet from '../views/Pet/index.vue'
import Service from '../views/Service/index.vue'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/rent',
            name: 'Rent',
            component: Rent
        },
        {
            path: '/transfer',
            name: 'Transfer',
            component: Transfer
        },
        {
            path: '/vich',
            name: 'Vich',
            component: Vich
        },
        {
            path: '/order',
            name: 'Order',
            component: Order
        },
        {
            path: '/wantjob',
            name: 'Wantjob',
            component: Wantjob
        },
        {
            path: '/pet',
            name: 'Pet',
            component: Pet
        },
        {
            path: '/service',
            name: 'Service',
            component: Service
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        }
    ]
})
